import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
// import PageBanner from '../components/PageBanner/PageBanner';
import './YogaCourses.css';

// Import images

function YogaCourses() {
    const { t } = useLanguage();
    // const [selectedLevel, setSelectedLevel] = useState('all');


    // const filteredCourses = selectedLevel === 'all'
    //     ? courses
    //     : courses.filter(course => course.level === selectedLevel);

    return (
        <div className="yoga-courses-page">


            {/* Page Header */}


            {/* 40 Days Training Highlight Section */}
            <section className="training-highlight-section">
                <div className="container">
                    <div className="highlight-content">
                        <div className="highlight-header" data-aos="fade-up">
                            <h2>{t('yoga_courses.training.title')}</h2>
                            <p>{t('yoga_courses.training.subtitle')}</p>
                        </div>

                        <div className="highlight-features-grid">
                            <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="100">
                                <div className="feature-icon-highlight">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                                        <path d="M20.5 11h-1v10l8.6 5.2.7-1.1-8.3-5V11z" fill="currentColor" />
                                    </svg>
                                </div>
                                <h3>{t('yoga_courses.training.f1_title')}</h3>
                                <p>{t('yoga_courses.training.f1_desc')}</p>
                            </div>

                            <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="150">
                                <div className="feature-icon-highlight">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                                        <path d="M14 20c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6zm8 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z" fill="currentColor" />
                                    </svg>
                                </div>
                                <h3>{t('yoga_courses.training.f2_title')}</h3>
                                <p>{t('yoga_courses.training.f2_desc')}</p>
                            </div>

                            <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="200">
                                <div className="feature-icon-highlight">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                                        <path d="M15 18h10v-2H15v2zm0 4h10v-2H15v2z" fill="currentColor" />
                                    </svg>
                                </div>
                                <h3>{t('yoga_courses.training.f3_title')}</h3>
                                <p>{t('yoga_courses.training.f3_desc')}</p>
                            </div>

                            <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="250">
                                <div className="feature-icon-highlight">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                                        <path d="M26.7 14.5L17 24.2l-5.7-5.7-1.4 1.4L17 27l11.1-11.1-1.4-1.4z" fill="currentColor" />
                                    </svg>
                                </div>
                                <h3>{t('yoga_courses.training.f4_title')}</h3>
                                <p>{t('yoga_courses.training.f4_desc')}</p>
                            </div>

                            <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="300">
                                <div className="feature-icon-highlight">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                                        <path d="M14 20c0 3.31 2.69 6 6 6s6-2.69 6-6-2.69-6-6-6-6 2.69-6 6zm8 0c0 1.1-.9 2-2 2s-2-.9-2 2 .9 2 2 2 2-.9 2-2z" fill="currentColor" />
                                    </svg>
                                </div>
                                <h3>{t('yoga_courses.training.f5_title')}</h3>
                                <p>{t('yoga_courses.training.f5_desc')}</p>
                            </div>

                            <div className="highlight-feature" data-aos="zoom-in" data-aos-delay="350">
                                <div className="feature-icon-highlight">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <path d="M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 32c-7.73 0-14-6.27-14-14S12.27 6 20 6s14 6.27 14 14-6.27 14-14 14z" fill="currentColor" />
                                        <path d="M20 10c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor" />
                                    </svg>
                                </div>
                                <h3>{t('yoga_courses.training.f6_title')}</h3>
                                <p>{t('yoga_courses.training.f6_desc')}</p>
                            </div>
                        </div>

                        <div className="highlight-cta" data-aos="fade-up">
                            <Link to="/booking" className="btn btn-primary btn-large">
                                {t('yoga_courses.training.enroll_btn')}
                                <span className="btn-icon">→</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="courses-cta">
                <div className="container">
                    <div className="cta-content" data-aos="zoom-in">
                        <h2>{t('yoga_courses.cta.title')}</h2>
                        <p>{t('yoga_courses.cta.desc')}</p>
                        <div className="cta-buttons">
                            <a href="/booking" className="btn btn-primary">{t('yoga_courses.cta.book_btn')}</a>
                            <a href="/trainers" className="btn btn-outline">{t('yoga_courses.cta.meet_btn')}</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default YogaCourses;
